import { createColumnHelper } from '@tanstack/react-table'
import { useDispatch, useSelector } from 'react-redux'
import { selectTranslations } from '../../../services/i18n/i18nSlice'
import { useEffect, useRef, useState } from 'react'

import '../UserTable.css'
import { usePagination } from '../../../components/Table/usePagination'
import { useSorting } from '../../../components/Table/useSorting'
import { Table } from '../../../components/Table/Table'

import IndeterminateCheckbox from '../../../components/Table/Checkbox'


export default function UserReducedTable(props) {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()
    
    const columnHelper = createColumnHelper()

    const [count, setCount] = useState(0);
    const [loadingData, setLoadingData] = useState(false);
    const [searchFilter, setSearchFilter] = useState("")
    const tableRef = useRef()

    // Make some columns!
    const defaultColumns = [
        {
            id: 'select',
            header: ({ table }) => (
            <IndeterminateCheckbox
                {...{
                checked: table.getIsAllRowsSelected(),
                indeterminate: table.getIsSomeRowsSelected(),
                onChange: table.getToggleAllRowsSelectedHandler(),
                }}
            />
            ),
            cell: ({ row }) => (
            <div className="px-1">
                <IndeterminateCheckbox
                {...{
                    checked: row.getIsSelected(),
                    disabled: !row.getCanSelect(),
                    indeterminate: row.getIsSomeSelected(),
                    onChange: row.getToggleSelectedHandler(),
                }}
                />
            </div>
            ),
        },
    // Display Column
        columnHelper.accessor('email', {
            cell: user => user.getValue(),
            header: () => <span>E-Mail</span>
        }),
        columnHelper.accessor('firstname', {
            cell: user => user.getValue(),
            header: () => <span>{t.users.fields.firstname}</span>
        }),
        columnHelper.accessor('lastname', {
            cell: user => user.getValue(),
            header: () => <span>{t.users.fields.lastname}</span>
        }),
    ]

    const { limit, onPaginationChange, skip, pagination } = usePagination();

    const { sorting, onSortingChange, field, order } = useSorting();

    const pageCount = Math.round(props.data?.length / limit) +1;

    return (
        <div>
            <div className='table_container'>
                <div className=''>
                    <div id='userSearchBar' className='reduced_table'>
                        <input type='text' placeholder={t.users.search_users} value={searchFilter} onChange={(e)=>setSearchFilter(e.target.value)} />
                    </div>                
                </div>
                <Table
                    ref={tableRef}
                    cols={defaultColumns}
                    data={props.data || []}
                    loading={loadingData}
                    onPaginationChange={onPaginationChange}
                    onSortingChange={onSortingChange}
                    pageCount={pageCount}
                    pagination={pagination}
                    sorting={sorting}
                    enableRowSelection={true} 
                    autoResetSelectedRows={true}
                    autoResetPageIndex={true}
                    onRowSelectionChange={props.setRowSelection}
                    rowSelection={props.rowSelection}
                    getRowId={(row)=>row.user_id}
                    manualPagination={false}
                    globalFilter={searchFilter}
                    onGlobalFilterChange={setSearchFilter}
                />
            </div>
            
        </div>
        
    );
}

